import { createSelector } from 'reselect';
import moment from 'moment';

import { COLORS, SHOWN_TYPE_ERLEDIGTE } from '../helpers/constants';

import DateHelper from '../helpers/date-helper';
import mergeChangesWithAppointment from '../helpers/appointment-changes-merge';

export default () => createSelector(
    (state) => { return state.tasks.appointments },
    (state) => { return state.tasks.enteredData },
    (state) => { return state.tasks.shownType },
    (state) => { return state.tasks.positions },
    (state, props) => { return props.day },
    (apps, enteredData, shownType, positions, day) => {

        const dh = new DateHelper();
        const date = dh.getDateByIndex(day);
        const dayApps =  apps.filter(app => {
            const appDuration = dh.appDuration(moment(app.DestinationDate),moment(app.EndDatum));
            if(appDuration===0)//ako appointment traje 1 dan
            {
                return dh.isTheSameDate(moment(app.DestinationDate), date);
            }
            else//ako appointment traje više dana
            {
                let previous = dh.isTheSameDate(moment(app.DestinationDate), date);
                for(let i =0;i<=appDuration;i++)
                {
                    previous += dh.isTheSameDate(moment(app.DestinationDate).add(i,'d'), date);
                }
                return previous;
            }
        });
        let merged = dayApps.map(app => {
            if (positions) {
                const positionsAu = positions.filter(c=>c.AuftragId === app.AuftragNr);
                if (positionsAu) app.positionsCount=positionsAu.length;
            }
            const modifiedData = enteredData.find(c => c.UniqueID === app.UniqueID); //c.IDService === app.IDService &&
            if (!modifiedData) return app;
            return mergeChangesWithAppointment(app, modifiedData);
        });

//Boje na DayTask
        if(merged.length !== 0){
            let lastKunde = { kunde: merged[0].Kunde, color: 0 }
            merged.forEach((e, index) => {

                if (lastKunde.kunde === merged[index].Kunde) {
                    e["color"] = COLORS[lastKunde.color];
                } else {
                    lastKunde.kunde = merged[index].Kunde;
                    lastKunde.color = lastKunde.color + 1;
                    e["color"] = COLORS[lastKunde.color];
                }
            });
        }
        if(shownType === SHOWN_TYPE_ERLEDIGTE){
            return merged.filter(app => app.Geliefert === 1).sort((a, b) => { return a.DestinationDate < b.DestinationDate?-1:1 });
        }else{
            return merged.filter(app => app.Geliefert !== 1).sort((a, b) => { return a.DestinationDate < b.DestinationDate?-1:1 });
        }

        
    }
)